module.exports = __webpack_public_path__ + "static/media/arg.3c483827.svg";